<form [formGroup]="group" class="ratings-form">
    <fieldset class="rating">
        <input type="radio" name="ratings" formControlName="ratings" value="5" [checked]="rating==5"/>
        <label title="{{'interviews.5 stars' | translate}}" (click)='onClick(5)'>{{'interviews.5 stars' | translate}}</label>

        <input type="radio" name="ratings" formControlName="ratings" value="4" [checked]="rating==4"/>
        <label title="{{'interviews.4 stars' | translate}}" (click)='onClick(4)'>{{'interviews.4 stars' | translate}}</label>

        <input type="radio" name="ratings" formControlName="ratings" value="3" [checked]="rating==3"/>
        <label title="{{'interviews.3 stars' | translate}}" (click)='onClick(3)'>{{'interviews.3 stars' | translate}}</label>

        <input type="radio" name="ratings" formControlName="ratings" value="2" [checked]="rating==2"/>
        <label title="{{'interviews.2 stars' | translate}}" (click)='onClick(2)'>{{'interviews.2 stars' | translate}}</label>

        <input type="radio" name="ratings" formControlName="ratings" value="1" [checked]="rating==1"/>
        <label title="{{'interviews.1 star' | translate}}" (click)='onClick(1)'>{{'interviews.1 star' | translate}}</label>
    </fieldset>
</form>
